<template>
  <div style="margin: -15px;">
    <div style="height: calc(100vh - 100px); overflow-y: auto;padding: 15px;">
      <el-form
        ref="formData"
        :model="formData"
        size="small"
        label-width="160px"
        :label-position="$i18n.locale !== 'zh' ? 'top' : 'right'"
      >
        <!--结算类型 AJD账单才显示-->
        <el-form-item
          v-if="type === 2"
          :label="$t('GlobalSetObj.settlementType') + '：'"
          prop="settlementType"
          :rules="[
            { required: true, message: $t('GlobalSetObj.pleaseChoose'), trigger: ['blur', 'change'] }
          ]"
          style="padding-inline: 20px;margin-bottom: 5px;"
        >
          <el-select
            v-model="formData.settlementType"
            :placeholder="$t('GlobalSetObj.pleaseChoose')"
            filterable
            clearable
            style="width: 400px;"
          >
            <el-option key="0" label="RPA" value="RPA" />
            <el-option key="1" label="CNPJ" value="CNPJ" />
          </el-select>
        </el-form-item>
        <el-card style="margin-bottom: 10px">
          <!--          付款-->
          <div>
            <el-form-item
              :label="$t('basicData.PaymentMethod')"
              prop="paymentMethod"
              :rules="[
                { required: true, message: $t('GlobalSetObj.pleaseChoose'), trigger: ['blur', 'change'] }
              ]"
            >
              <el-checkbox-group v-model="formData.paymentMethod">
                <el-checkbox :label="1">pix</el-checkbox>
                <el-checkbox :label="2">{{ $t('basicData.bankTransfer') }}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
        </el-card>
        <el-card>
          <div style="margin-bottom: 10px">
            <!--PIX转账-->
            <span>{{ 'PIX' + $t('basicData.transferable') }}</span>
          </div>
          <!--PIX账号类型-->
          <el-form-item
            :label="'PIX' + $t('receivablePayable.accountType') + '：'"
            prop="dictCodeType"
            :rules="[
              formData.paymentMethod.includes(1)?
                { required: true, message: $t('GlobalSetObj.pleaseChoose'), trigger: ['blur', 'change'] }:{required:false}
            ]"
          >
            <el-select
              v-model="formData.dictCodeType"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              filterable
              clearable
              style="width: 400px;"
            >
              <el-option key="0" label="CPF" value="CPF" />
              <el-option key="1" label="CNPJ" value="CNPJ" />
              <el-option key="2" label="MOBILE PHONE" value="MOBILE PHONE" />
              <el-option key="3" label="EMAIL" value="EMAIL" />
              <el-option key="4" label="EVP" value="EVP" />
            </el-select>
          </el-form-item>
          <!--PIX账号-->
          <el-form-item
            :label="'PIX' + $t('customerManagements.account') + '：'"
            prop="dictCode"
            :rules="[
              formData.paymentMethod.includes(1)?
                { required: true, message: $t('GlobalSetObj.pleaseInput'), trigger: ['blur', 'change'] }:{required:false}
            ]"
          >
            <el-input
              v-model="formData.dictCode"
              clearable
              :placeholder="$t('GlobalSetObj.pleaseInput')"
              style="width: 400px;"
            />
          </el-form-item>
        </el-card>
        <el-card style="margin-top: 5px;">
          <div style="margin-bottom: 10px">
            <!--银行转账-->
            <span>{{ $t('basicData.bankTransfer') }}</span>
          </div>
          <!--收款名称-->
          <el-form-item
            :label="$t('basicData.ReceivingName') + '：'"
            prop="payeeName"
            :rules="[
              formData.paymentMethod.includes(2)?
                { required: true, message: $t('GlobalSetObj.pleaseInput'), trigger: ['blur', 'change'] }:{required:false}
            ]"
          >
            <el-input
              v-model="formData.payeeName"
              clearable
              :placeholder="$t('GlobalSetObj.pleaseInput')"
              style="width: 400px;"
            />
          </el-form-item>
          <!--证件类型-->
          <el-form-item
            :label="$t('orderCenterCont.CertificateType') + '：'"
            prop="documentType"
            :rules="[
              formData.paymentMethod.includes(2)?
                { required: true, message: $t('GlobalSetObj.pleaseChoose'), trigger: ['blur', 'change'] }:{required:false}
            ]"
          >
            <el-select
              v-model="formData.documentType"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              filterable
              clearable
              style="width: 400px;"
            >
              <el-option key="0" label="CPF" value="CPF" />
              <el-option key="1" label="CNPJ" value="CNPJ" />
            </el-select>
          </el-form-item>
          <!--证件号码-->
          <el-form-item
            :label="$t('basicData.CertificateNumber') + '：'"
            prop="documentNumber"
            :rules="[
              formData.paymentMethod.includes(2)?
                { required: true, validator: validateNumber, trigger: ['blur', 'change'] }:{required:false}
            ]"
          >
            <el-input
              v-model="formData.documentNumber"
              clearable
              :placeholder="$t('GlobalSetObj.pleaseInput')"
              style="width: 400px;"
            />
          </el-form-item>
          <!--银行编号-->
          <el-form-item
            :label="$t('basicData.BankNumber') + '：'"
            prop="bankCode"
            :rules="[
              formData.paymentMethod.includes(2)?
                { required: true, message: $t('GlobalSetObj.pleaseChoose'), trigger: ['blur', 'change'] }:{required:false}
            ]"
          >
            <el-select
              v-model="formData.bankCode"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              filterable
              clearable
              style="width: 400px;"
            >
              <el-option
                v-for="item in bankList"
                :key="item.id"
                :label="item.code + '（' + item.name + '）-' + item.ispd"
                :value="item.code"
              />
            </el-select>
          </el-form-item>
          <!--分行号码-->
          <el-form-item
            :label="$t('basicData.BranchNumber') + '：'"
            prop="branch"
            :rules="[
              formData.paymentMethod.includes(2)?
                { required: true, validator: validateNumber, trigger: ['blur', 'change'] }:{required:false}
            ]"
          >
            <el-input
              v-model="formData.branch"
              clearable
              :placeholder="$t('GlobalSetObj.pleaseInput')"
              style="width: 400px;"
            />
          </el-form-item>
          <!--收款账户-->
          <el-form-item
            :label="$t('basicData.ReceivingAccountNumber') + '：'"
            prop="bankNumber"
            :rules="[
              formData.paymentMethod.includes(2)?
                { required: true, validator: validateNumber, trigger: ['blur', 'change'] }:{required:false}
            ]"
          >
            <el-input
              v-model="formData.bankNumber"
              clearable
              :placeholder="$t('GlobalSetObj.pleaseInput')"
              style="width: 400px;"
            />
          </el-form-item>
        </el-card>
      </el-form>
    </div>
    <div style="padding: 10px;text-align: right;border-top: 1px solid #ccc;">
      <el-button size="small" @click="onClose()">{{ $t('GlobalSetObj.cancel') }}</el-button>
      <el-button
        v-permit:remove="permission"
        size="small"
        type="primary"
        @click="submitForm"
      >
        {{ $t('basicData.Save') }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { apiDeliveryPayableAccountEdit, apiHutPayableAccountEdit } from '@/api/newFinance';
import { cloneDeep } from 'lodash-es';

export default {
  name: 'PaymentData',
  props: {
    bankList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    detailData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    // 应付账户类型 1：安骏 2：AJD 3：DSP
    type: {
      type: [String, Number],
      required: true
    }
  },

  data() {
    // 0-9的数字
    const validateNumber = (rule, value, callback) => {
      const regex = /^[0-9]*$/;
      if (rule.required) {
        if (value === '' || value === null || value === undefined) {
          callback(new Error(this.$t('GlobalSetObj.pleaseInput')));
        } else {
          if (!regex.test(value)) {
            callback(new Error(this.$t('collectionCenter.inputNum')));
          } else {
            callback();
          }
        }
      } else if (value !== '' && value !== null && value !== undefined) {
        if (!regex.test(value)) {
          callback(new Error(this.$t('collectionCenter.inputNum')));
        } else {
          callback();
        }
      }
    };
    return {
      formData: {
        id: this.detailData.id,
        settlementType: null, // 结算类型
        dictCodeType: '', // PIX账号类型
        dictCode: '', // PIX账号
        payeeName: '', // 收款名称
        documentType: null, // 证件类型
        documentNumber: '', // 证件号码
        bankCode: '', // 银行编号
        branch: '', // 分行号码
        bankNumber: '', // 收款账户
        paymentMethod: [] // 支付方式 1:pix 2:银行转账 3:pix和银行转账
      },
      validateNumber: validateNumber
    };
  },

  computed: {
    permission() {
      return this.getPermission();
    }
  },
  created() {
    const obj = cloneDeep(this.detailData);
    this.formData = {
      id: obj.id,
      settlementType: obj.settlementType ? obj.settlementType : null, // 结算类型
      dictCodeType: obj.dictCodeType ? obj.dictCodeType : null, // PIX账号类型
      dictCode: obj.dictCode ? obj.dictCode : null, // PIX账号
      payeeName: obj.payeeName ? obj.payeeName : '', // 收款名称
      documentType: obj.documentType ? obj.documentType : null, // 证件类型
      documentNumber: obj.documentNumber ? obj.documentNumber : '', // 证件号码
      bankCode: obj.bankCode ? obj.bankCode : '', // 银行编号
      branch: obj.branch ? obj.branch : '', // 分行号码
      bankNumber: obj.bankNumber ? obj.bankNumber : '', // 收款账户
      paymentMethod: obj.paymentMethod ? obj.paymentMethod !== 3 ? [obj.paymentMethod] : [1, 2] : []
    };
  },
  methods: {
    // 关闭
    onClose() {
      this.bus.$emit('onClose', false);
    },
    // 保存
    submitForm() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          const params = {
            id: this.formData.id,
            settlementType: this.formData.settlementType,
            dictCodeType: this.formData.dictCodeType,
            dictCode: this.formData.dictCode,
            payeeName: this.formData.payeeName,
            documentType: this.formData.documentType,
            documentNumber: this.formData.documentNumber,
            bankCode: this.formData.bankCode,
            branch: this.formData.branch,
            bankNumber: this.formData.bankNumber,
            paymentMethod: this.formData.paymentMethod?.length === 2 ? 3 : this.formData.paymentMethod[0]
          };
          const api = this.type === 1 ? apiHutPayableAccountEdit : apiDeliveryPayableAccountEdit;
          api(params).then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
              this.bus.$emit('onClose', true);
            }
          });
        }
      });
    },
    // 编辑权限
    getPermission() {
      switch (this.type) {
        case 1: // 安俊
          return 'but:finance:basicData:payable:hutdispatchAccountsPayable:edit';
        case 2: // AJD
          return 'but:finance:basicData:payable:dispatchAccountsPayable:edit';
        case 3: // DSP
          return 'but:finance:basicData:payable:dspdispatchAccountsPayable:edit';
        default:
          return '';
      }
    }
  }
};
</script>

<style scoped>

</style>
